export default "__VITE_ASSET__Dt3Q6EsE__"